import React from 'react';
import './Savings.css';

const Savings: React.FC = () => {
  return (
    <section className="savings-section">
      <div className="savings-container">
        <div className="savings-grid-layout">
          {/* Horizontal line connecting the first three columns at top */}
          <div className="savings-horizontal-line savings-horizontal-line-top"></div>
          {/* Horizontal line connecting the first three columns at bottom */}
          <div className="savings-horizontal-line savings-horizontal-line-bottom"></div>
          
          <div className="savings-item savings-item-left">
            <div className="percentage-badge">1.25%</div>
            <h3 className="savings-item-title">Can save to Buy new home with us</h3>
            <p className="savings-item-description">
              Save more when you buy your new home with us. We secure the best mortgage rates for your budget. Experience a smooth, stress-free homebuying process with personalized support.
            </p>
          </div>
          
          <div className="savings-item savings-item-middle">
            <div className="percentage-badge">1.75%</div>
            <h3 className="savings-item-title">Can save to Refinance your home with us</h3>
            <p className="savings-item-description">
              Refinance and save with our highly competitive rates. Lower your monthly payments or access your home's equity with ease. We make refinancing quick, simple, and efficient for long-term savings.
            </p>
          </div>
          
          <div className="savings-item savings-item-middle">
            <div className="percentage-badge">2.25%</div>
            <h3 className="savings-item-title">Can save when apply for Reverse mortgage</h3>
            <p className="savings-item-description">
              Unlock your home's value and save for a more secure retirement. Get the best reverse mortgage rates, tailored specifically to your financial goals. Enjoy financial freedom without monthly payments.
            </p>
          </div>
          
          <div className="savings-item cta-item savings-item-right">
            <div className="cta-content">
              <h3 className="cta-title">We will find great rate for you</h3>
              <button className="cta-button">Get your rate</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Savings;
